import { useForm } from "react-hook-form";
import CountryCodeInput from "../../Components/CommonCommponents/CountyCodeInput";
import Input from "../../Components/CommonCommponents/Input";
import { Button, message } from "antd";
import { logDOM } from "@testing-library/react";
import CandodateService from "../../Service.js/CandidateService";
import toast from "react-hot-toast";

const RequiredFeildsContactDetails = (props) => {
  const [messageApi, messageContextHolder] = message.useMessage();
  console.log("test", props.fields);

  const {
    clearErrors,
    register,
    handleSubmit,
    setValue,
    getValues,
    control,
    setError,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    mode: "all",
    defaultValues: {},
  });

  const fieldVisible = (name) => {
    console.log("testname", name);
    const { fields } = props;
    let value = false;
    if (fields?.includes(name)) {
      value = true;
    }
    return value;
  };

  const onSubmit = async (data) => {
    console.log(data, "datadata");
    let candidate_fields = [
      "first_name",
      "last_name",
      "email",
      "mobile_number",
    ];
    let result = {};
    let candidate_credentials = {};
    let keysData = Object.keys(data);
    keysData?.map((k) => {
      if (fieldVisible(k)) {
        console.log("ENTERRR", k);
        if (candidate_fields.includes(k)) {
          candidate_credentials[k] = data[k];
        }
      }
    });
    if (candidate_credentials["mobile_number"]) {
      let country = "+91";
      if (data?.country_code) {
        country = "+" + data?.country_code;
      }
      candidate_credentials["mobile_number"] = country + data["mobile_number"];
    }
    result = candidate_credentials;

    console.log(result, "resultresult");
    await CandodateService.updateContactDetails(result, props.userId)
      .then(
        (response) => {
          if (response.data.success == true) {
            toast.success("Successfully Updated!");
          }
          props?.setEnable(true);
          props?.setRequiredFields([]);
        },
        (error) => {
          const errorsObj = error.response.data.error_info;
          Object.keys(errorsObj).forEach((field) => {
            const messages = errorsObj[field];
            setError(field, {
              type: "server",
              message: messages.join(". "),
            });
          });
        }
      )
      .catch((error) => {
        toast.error("Failed To Update");
      });
  };
  return (
    <>
      <div className="edit_candidate_maindiv">
        {messageContextHolder}
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="editCandidate_form w-full">
            <div
              className={`form_content ${
                fieldVisible("first_name") ? "block" : "hidden"
              }`}
            >
              <Input
                name="first_name"
                label={
                  <p>
                    First Name<span className="text-errorMain">*</span>
                  </p>
                }
                control={control}
                placeholder="First Name"
                rules={{
                  required: fieldVisible("first_name")
                    ? "This field is required"
                    : false,
                  pattern: {
                    value: /^[a-zA-Z]+$/,
                    message: "Please enter letters only",
                  },
                }}
              />
            </div>
            <div
              className={`form_content ${
                fieldVisible("last_name") ? "block" : "hidden"
              }`}
            >
              <Input
                name="last_name"
                label={
                  <p>
                    Last Name<span className="text-errorMain">*</span>
                  </p>
                }
                control={control}
                placeholder="Last Name"
                rules={{
                  required: fieldVisible("last_name")
                    ? "This field is required"
                    : false,
                  pattern: {
                    value: /^[a-zA-Z]+$/,
                    message: "Please enter letters only",
                  },
                }}
              />
            </div>
            <div
              className={`form_content ${
                fieldVisible("email") ? "block" : "hidden"
              }`}
            >
              <Input
                name="email"
                label={
                  <p>
                    Email ID<span className="text-errorMain">*</span>
                  </p>
                }
                control={control}
                placeholder="Email ID"
                rules={{
                  required: fieldVisible("email")
                    ? "This field is required"
                    : false,
                }}
              />
            </div>
            <div
              className={`form_content ${
                fieldVisible("mobile_number") ? "block" : "hidden"
              }`}
            >
              <CountryCodeInput
                name="mobile_number"
                country_code_name="country_code"
                country_code_value={watch("country_code")}
                value={watch("mobile_number")}
                setValue={setValue}
                label="Contact Number"
                placeholder="Contact Number"
                required={true}
                control={control}
                rules={{
                  required: fieldVisible("mobile_number")
                    ? "This field is required"
                    : false,
                  pattern: {
                    value: /^[0-9]+$/,
                    message: "Please enter only numbers",
                  },
                }}
              />
            </div>
          </div>
          <div className="float-right mt-4">
            <Button type="primary" className="ml-4" htmlType="submit">
              Submit
            </Button>
          </div>
        </form>
      </div>
    </>
  );
};
export default RequiredFeildsContactDetails;
